import React from 'react'
import PropType from 'prop-types'
import Collapse from '@material-ui/core/Collapse'

const Transitions = ({ children, isExpanded, type }) => (
  type === 'collapse' && (
    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
      { children }
    </Collapse>
  )
)

Transitions.defaultProps = {
  isExpanded: true,
  type: 'collapse',
}

Transitions.propTypes = {
  children: PropType.node.isRequired,
  isExpanded: PropType.bool,
  type: PropType.oneOf(['collapse']),
}

export default Transitions
